import { BotMessageSquare } from "lucide-react";
import { useState } from "react";
import type { AgentAppView } from "../types.js";

export function AppIcon({ app }: { app: AgentAppView }) {
  const source = app.activeDeploymentId
    ? `/v1/apps/${encodeURIComponent(app.id)}/deployments/${encodeURIComponent(app.activeDeploymentId)}/icon`
    : null;
  const [failedSource, setFailedSource] = useState<string | null>(null);
  if (app.identityStatus === "pending") return <ChatIcon />;
  const showImage = source !== null && failedSource !== source;
  const initial =
    (app.name ?? "").trim().charAt(0).toLocaleUpperCase() || "A";
  return (
    <span className="a3-app-icon" aria-hidden="true">
      {showImage ? (
        <img
          src={source}
          alt=""
          width="34"
          height="34"
          decoding="async"
          onError={() => setFailedSource(source)}
        />
      ) : (
        <span className="a3-app-icon-fallback">{initial}</span>
      )}
    </span>
  );
}

export function ChatIcon() {
  return (
    <span className="a3-app-icon" data-kind="chat" aria-hidden="true">
      <BotMessageSquare />
    </span>
  );
}
